import { Plus, Users } from "lucide-react";
import { ApprovalFlowCard } from "../component/approvalCard";
import { CreateApprovalFlowDialog } from "./createApprovalFlowDialog";
import Toast from "../../../../../components/Toast";
import { hideToast, setListLoading } from "../viewmodel/approvalFlow.action";
import {
  ApprovalFlowDetailsData,
  ApprovalFlowGetData,
} from "../model/approvalsFlowModel";
import { ConfirmDeleteModal } from "../../../../../components/ConfirmationPopUp";

export const ApprovalFlowView = ({
  approvalVM,
  approvalFlowVM,
}: {
  approvalVM: any;
  approvalFlowVM: any;
}) => {
  // Extend ApprovalFlowState to include approvalFlows, pools, editingFlow, isFlowDialogOpen, etc.
  const { state, dispatch, deleteApprovalsData, fetchDetailedApprovals } =
    approvalFlowVM;
  const { editingFlow, isFlowDialogOpen = false } = state;
  // Helper functions to update dialog and editing state
  const setEditingFlow = (flow: ApprovalFlowGetData | undefined) => {
    dispatch({ type: "SET_EDITING_FLOW", payload: flow });
  };
  const setIsFlowDialogOpen = (open: boolean) => {
    dispatch({ type: "SET_FLOW_DIALOG_OPEN", payload: open });
  };
  const handleConfirmDelete = async () => {
    await deleteApprovalsData();
  };

  const handleSetDefaultFlow = (id: string) => {
    // Implement set default logic using dispatch
  };
  const handleSaveFlow = (
    flow: Omit<ApprovalFlowDetailsData, "id" | "createdAt">,
  ) => {
    // Implement save logic using dispatch
  };

  const refreshList = async () => {
    dispatch(setListLoading(true));
    await approvalFlowVM.fetchApprovals();
    dispatch(setListLoading(false));
  };
  const deletingFlow = state.approvalFlows.find(
    (flow: ApprovalFlowGetData) => flow.id === state.deletingFlowId,
  );
 
  return (
    <div>
      <div className="flex justify-end items-center mt-4 mb-4">
        <button
          onClick={() => {
            setEditingFlow(undefined);
            dispatch({ type: "SET_DIALOG_MODE", payload: "create" });
            setIsFlowDialogOpen(true);
          }}
          className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors flex items-center"
        >
          <Plus className="h-4 w-4 mr-2" />
          Create Approval Flow
        </button>
      </div>
      <div className="space-y-4">
        <div>
          {state.listLoading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
              {Array.from({ length: 8 }).map((_, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg shadow-sm border p-4 animate-pulse"
                >
                  <div className="flex items-center space-x-3 mb-3">
                    <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
                    <div className="flex-1">
                      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                      <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                    </div>
                  </div>

                  <div className="space-y-2">
                    <div className="h-3 bg-gray-200 rounded"></div>
                    <div className="h-3 bg-gray-200 rounded w-2/3"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : state.approvalFlows.length === 0 ? (
            <div className="px-6 py-12 text-center">
              <h3 className="text-sm font-medium text-gray-900">
                No approval flows found
              </h3>
              <p className="text-sm text-gray-500">
                Try adjusting your filters.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {state.approvalFlows.map((flow: ApprovalFlowGetData) => (
                <ApprovalFlowCard
                  key={flow.id}
                  flow={flow}
                  onEdit={(flow) => {
                    fetchDetailedApprovals(flow.id, "edit");
                  }}
                  onDelete={(id) => {
                    dispatch({ type: "OPEN_DELETE_DIALOG", payload: id });
                  }}
                  onSetDefault={handleSetDefaultFlow}
                  onDetails={(id) => {
                    fetchDetailedApprovals(id, "view");
                  }}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    
      <CreateApprovalFlowDialog
        mode={state.dialogMode}
        open={isFlowDialogOpen}
        onOpenChange={(open) => {
          setIsFlowDialogOpen(open);
          if (!open) setEditingFlow(undefined);
        }}
        onSave={handleSaveFlow}
        detailedFlow={state.detailedFlow}
        existingFlow={editingFlow}
        approvalVM={approvalVM}
        approvalFlowVM={approvalFlowVM}
        onSaveSuccess={refreshList}
      />
      <Toast
        message={state.toast.message}
        type={state.toast.type}
        isVisible={state.toast.isVisible}
        onClose={hideToast}
      />
      <ConfirmDeleteModal
        open={state.deleteDialogOpen}
        title="Delete Approval Flow?"
        entityName={deletingFlow?.name}
        loading={state.loading}
        onCancel={() => dispatch({ type: "CLOSE_DELETE_DIALOG" })}
        onConfirm={handleConfirmDelete}
      />
    </div>
  );
};
